import React from 'react';
import { MetricsTableContainer, Table } from './MetricsTable.styled';
import MetricsTableHead from './MetricsTableHead/MetricsTableHead';
import MetricsTableBody from './MetricsTableBody/MetricsTableBody';
import { connect, useSelector } from 'react-redux';
import { template_table_toggle_row, template_load_timeframe } from '../../../redux/reducers/templateSlice';
import { useWindowSize } from '../../../helpers/hooks/useWindowSize';
import { selectAuthenticated } from '../../../redux/reducers/authSlice';
import { selectTemplate } from '../../../redux/reducers/templateSlice';

interface IMetricsTableProps extends IMetricsTable, IMetricsTableHead {
   maxReached: boolean;
   collection;
}

interface IMetricsTable {
   TitleInTable: string;
   SubtitleInTable: string;
   TableRows: IMetricsTableRow[];
   MetricScaleMode: string;
   toggleRow;
}

export interface IMetricsTableBody {
   rows: IMetricsTableRow[];
   scale: string;
   maxReached: boolean;
   showData: boolean;
   toggleRow;
   windowSize;
}

export interface IMetricsTableHead {
   period: number;
   maximum: number;
   availableTimes: string[];
   headers: string[];
   templateId: string;
   collectionId: string;
   windowSize;
   loadTimeframe;
}

export interface IMetricsTableRow {
   Id: string;
   Charted?: boolean;
   GeographyId?: string;
   TableTitle: string;
   ChartTitle: string;
   SourceId?: string;
   HasData: boolean;
   Row: string;
   Level: string;
   Style: string;
   Values: number[];
   Precision: string;
   Type: string;
}

function mapStateToProps(state) {
   const chartedRows = state.template.tableRows.map(row => {
      let newRow: IMetricsTableRow = { ...row };
      newRow.Charted = state.template.charted[row.Row].IsCharted;
      return newRow;
   });

   return {
      TitleInTable: state.template.titleInTable,
      SubtitleInTable: state.template.subtitleInTable,
      TableRows: chartedRows,
      MetricScaleMode: state.template.metricScaleMode,
      period: state.template.period,
      maximum: state.template.maximumHeaders,
      availableTimes: state.template.availableTimes,
      headers: state.template.headers,
      showData: state.template.showData,
      maxReached: state.template.maxReached,
      collectionId: state.collection.id,
      templateId: state.collection.selectedTemplateId,
      collection: state.collection
   };
}

function mapDispatchToProps(dispatch, ownProps) {
   return {
      toggleRow: row => {
         dispatch(template_table_toggle_row(row));
      },
      loadTimeframe: (headers, id, collectionId) => {
         dispatch(
            template_load_timeframe({
               id: id,
               collectionId: collectionId,
               selectedHeaders: headers
            })
         );
      }
   };
}

const MetricsTable: React.FC<IMetricsTableProps> = props => {
   const { TableRows, MetricScaleMode, collection, templateId } = props;
   const windowSize = useWindowSize();
   const isLoaded = useSelector(selectTemplate).loaded;

   const isLoggedIn = useSelector(selectAuthenticated);
   const roleBenchmarks = useSelector((state: any) => state.auth.Benchmarks);
   const censor =
      (isLoggedIn || collection.selectedTemplateId) &&
      isLoggedIn &&
      collection.defaultTemplateId !== collection.selectedTemplateId &&
      collection.type === 'Benchmarks' &&
      !roleBenchmarks;
   const showData = (isLoggedIn || collection.defaultTemplateId === templateId) && !censor;

   return (
      isLoaded && (
         <MetricsTableContainer>
            <Table>
               <MetricsTableHead {...props} windowSize={windowSize} />
               <MetricsTableBody {...props} rows={TableRows} scale={MetricScaleMode} windowSize={windowSize} showData={showData} />
            </Table>
         </MetricsTableContainer>
      )
   );
};

export default connect(mapStateToProps, mapDispatchToProps)(MetricsTable);
